<template>
  <div class="DataTable-container">
    <div class="head-title">
      <p>{{ title }}</p>
    </div>
    <div class="select">
      <div class="DataNumber" v-if="selectData.length === 0">
        <p>共{{ totalnuberAll|| 0 }}条数据需求</p>
      </div>
      <div class="DataNumber-buttonList" v-if="selectData.length > 0">
        <p>已选择{{ selectData.length }}条</p>
        <div class="ButtonList">
          <div class="takenOffTheShelves" @click="handleShelves">下架</div>
          <div class="delete" @click="hanleDel">删除</div>
        </div>
      </div>
      <div class="select-input">
        <input
          placeholder="搜索"
          type="text"
          v-model="searchQuery"
          @keyup.enter="handleSearch"
        />
        <img :src="seach" alt="" />
      </div>
    </div>
    <div class="Datasets">
      <el-table
        :data="tableData1"
        style="width: 100%"
        :stripe="false"
        :row-style="{
          border: '1px solid #eee',
          borderRadius: '4px',
          marginTop: '5px',
        }"
        @select="handleSelect"
      >
        <el-table-column type="selection" width="30"> </el-table-column>
        <el-table-column label="主题" width="248">
          <template slot-scope="scope">
            <span class="DataSpan" @click="UpData(scope.row)">{{
              scope.row.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tags">
          <template slot="header" slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link disabled">
                行业分类<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item
                  v-for="item in industryList"
                  :key="item.value"
                  >{{ item.name }}</el-dropdown-item
                > -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <div class="industryList">
              <div
                class="industryList-item"
                v-for="item in scope.row.tags"
                :key="item"
              >
                {{ item }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="时间">
          <template slot-scope="scope">
            {{ formatDate(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link disabled">
                状态<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item v-for="item in statuList" :key="item.value">{{
                  item.name
                }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">草稿 </span>
            <span v-if="scope.row.status === 2">待审核</span>
            <span v-if="scope.row.status === 3">已发布</span>
            <span v-if="scope.row.status === 4">已驳回</span>
            <span v-if="scope.row.status === 5">已完成</span>
            <span v-if="scope.row.status === 6">已下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="My" v-if="type == 'My'">
              <el-button
                type="text"
                size="small"
                @click="setData(scope.row)"
                v-if="scope.row.status !== 2 && scope.row.status !== 3"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="
                  scope.row.status !== 4 &&
                  scope.row.status !== 5 &&
                  scope.row.status !== 6 &&
                  scope.row.status !== 1
                "
                @click="Shelves(scope.row)"
                >下架</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status !== 2 && scope.row.status !== 3"
                @click="publishBtn(scope.row)"
                >发布</el-button
              >
              <el-button
                type="text"
                size="small"
                class="delSpan"
                @click="DelScope(scope.row)"
                >删除</el-button
              >
            </div>

            <div class="response" v-if="type == 'responce'">
              <el-button type="text" size="small" @click="UpData(scope.row)"
                >查看</el-button
              >
            </div>
            <div class="rogerThat" v-if="type == 'rogerThat'">
              <el-button
                type="text"
                size="small"
                @click="LookData(scope.row)"
                v-if="scope.row.status !== 3"
                >查看</el-button
              >
              <el-button type="text" size="small" @click="Shelves(scope.row)" v-if="scope.row.status === 3||scope.row.status === 5">下架</el-button>
              <el-button type="text" size="small" class="delSpan" @click="DelScope(scope.row)"
                >删除</el-button
              >
            </div>
            <div class="rogerThat" v-if="type == 'MyPost'">
              <el-button
                type="text"
                size="small"
                @click="setData1(scope.row)"
                v-if="
                  scope.row.status === 1 ||
                  scope.row.status === 2 ||
                  scope.row.status === 4 ||
                  scope.row.status === 6
                "
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="publishBtn(scope.row)"
                v-if="scope.row.status === 1 || scope.row.status === 6"
                >发布</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="Shelves(scope.row)"
                v-if="scope.row.status === 3 || scope.row.status === 2"
                >下架</el-button
              >
              <el-button type="text" size="small" v-if="scope.row.status === 3"
                >已交付</el-button
              >

              <el-button type="text" size="small" class="delSpan"
                @click="DelScope(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[5, 10]"
        @current-change="currentChange"
        :page-size="pageSize"
        @size-change="sizeChange"
        layout="total, prev, pager, next,  sizes,jumper"
        :total="totalnuberAll"
      >
      </el-pagination>
    </div>
    <DiaLog
      :visible.sync="isDel"
      title="确认删除需求"
      :content="`确认删除这${selectData.length}条数据需求吗?`"
      :type="2"
      @Del="DelList"
      @confirm="hanleOk"
    >
      <span>确定要删除选中的数据吗？</span>
    </DiaLog>
  </div>
</template>

<script>
import { Message } from "element-ui";

import { formatDate } from "@/utils/Date";
import {
  GetRequierments,
  PatchRequierments,
  DelRequierments,
  DelOneRequierments,
  SearchRequierments,
} from "@/api/file";
import DiaLog from "@/components/DiaLog.vue";
import seach from "@/assets1/已发布数据集-已选_slices/搜索.png";
import wj from "@/assets1/已发布数据集-已选_slices/编组 8.png";
export default {
  components: {
    DiaLog,
  },
  props: {
    type: String,
    title: String,
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      ViewData: [],
      pageSize: 5,
      tableData1: [],
      seach,
      checkAll: false,
      wj,
      totalnuberAll:0,
      itemList: [false, false, false],
      isDel: false,
      cursorList: [],
      industryList: [
        {
          name: "工业制造",
          value: "1",
        },
        {
          name: "交通运输",
          value: "2",
        },
        {
          name: "金融服务",
          value: "3",
        },
        {
          name: "科技创新",
          value: "4",
        },
        {
          name: "绿色低碳",
          value: "5",
        },
        {
          name: "气象服务",
          value: "6",
        },
        {
          name: "商贸流通",
          value: "7",
        },
        {
          name: "文化旅游",
          value: "8",
        },
        {
          name: "现代农业",
          value: "9",
        },
        {
          name: "医疗健康",
          value: "10",
        },
        {
          name: "应急管理",
          value: "11",
        },
        {
          name: "城市治理",
          value: "12",
        },
      ],
      statuList: [
        {
          name: "草稿",
          value: 1,
        },
        {
          name: "待审核",
          value: 2,
        },
        {
          name: "已发布",
          value: 3,
        },
        {
          name: "已下架",
          value: 4,
        },
        {
          name: "被驳回",
          value: 5,
        },
        {
          name: "已完成",
          value: 6,
        },
      ],
      totalnuber: "",
      selectData: [],
      cursorList: [],
    };
  },
  async created() {
    console.log(this.$props.title,'this.title');
    console.log(this.$props.type,'this.type');
    
    await this.getViewData()
    console.log("getAll completed, cursorList length:", this.cursorList.length);
    this.getList();
    console.log(this.$props.type, "this.type");
  },
  computed: {},
  watch: {
    itemList(newValue) {
      const istrue = Array.from(newValue).every((item) => {
        return item === true;
      });
      if (istrue === true) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
  },
  methods: {
   async DelList(){
  const res=   await DelOneRequierments(this.data)
  console.log(res,'res');
  Message({
        type: "success",
        message: "删除成功",
      });
      this.$router.back()
    },
    async getViewData(){
      this.cursorList=[]
      await this.getAll()
    },
    async getAll(currentCursor = null) {
      
      try {
        const params = {
          page_size: this.pageSize, // 增大每页数量以减少请求次数
          // filter_status: 2,
          // filter_tags: '工业制造'
        };
        // 如果有游标，添加到参数中
        if (currentCursor) {
          params.cursor = currentCursor;
          console.log(currentCursor, "currentCursor");
        }
        const res = await GetRequierments(params);

        // 累加当前页的数据量
        if (res && res.requirements) {
          console.log("API response:", res);
          console.log("requirements length:", res.requirements.length);
          this.cursorList.push(...res.requirements);
          console.log("cursorList after push, length:", this.cursorList.length);
        } else {
          console.log("No requirements in response or response is invalid:", res);
        }

        // 检查是否还有下一页
        if (res && res.next_cursor && res.next_cursor !== "0") {
          // 递归调用获取下一页数据
          await this.getAll(res.next_cursor);
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        throw error;
      }
    },

    async Shelves(data) {
      console.log(data);
      const res = await PatchRequierments({
        ids: [data.id],
        status: 6,
      });
      console.log(res, "res");
      await this.getViewData()
      this.getList();
      Message({
        type: "success",
        message: "下架成功",
      });
    },
    async handleSearch() {
      const list = [];
      if (this.searchQuery) {
        this.currentPage = 1;
        
        
        // 先获取第一页数据来确定总数
        const firstRes = await SearchRequierments({
          page_no: 1,
          page_size: this.pageSize,
          keyword: this.searchQuery,
        });
        
        if (firstRes && firstRes.requirements) {
          // 将第一页数据添加到list中
          list.push(...firstRes.requirements);
          
          // 计算总页数
          const totalPages = Math.ceil(firstRes.total / this.pageSize);
          console.log(`总条数: ${firstRes.total}, 每页大小: ${this.pageSize}, 总页数: ${totalPages}`);
          
          // 如果总页数大于1，继续获取剩余页面的数据
          if (totalPages > 1) {
            for (let page = 2; page <= totalPages; page++) {
              try {
                const res = await SearchRequierments({
                  page_no: page,
                  page_size: this.pageSize,
                  keyword: this.searchQuery,
                });
                
                if (res && res.requirements) {
                  list.push(...res.requirements);
                  console.log(`第${page}页数据获取成功，当前list长度: ${list.length}`);
                }
              } catch (error) {
                console.error(`获取第${page}页数据失败:`, error);
              }
            }
          }
          
          // 将所有数据赋值给cursorList
          this.cursorList = list;
          this.totalnuberAll = firstRes.total;
          console.log(`搜索完成，总共获取到 ${list.length} 条数据`);
          
          // 调用getList处理数据
          this.getList();
        }
      } else {
        this.currentPage = 1;
        await this.getViewData()
        this.getList();
      }
    },
    currentChange(e) {
      this.currentPage = e;
      this.getList(e);
    },
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      console.log(val);
      this.getList();
    },
    async DelScope(data) {
      const res = await DelOneRequierments(data);
      console.log(res);
      Message({
        message: "删除成功",
        type: "success",
      });
      // await this.getViewData()
      this.cursorList=this.cursorList.filter((item)=>{
        if(item.id!==data.id){
          return item
        }
      })
      this.totalnuberAll=this.totalnuberAll-1
      this.getList();
    },
    async publishBtn(data) {
      console.log(data);
      const res = await PatchRequierments({
        ids: [data.id],
        status: 2,
      });
      console.log(res);
      await this.getViewData()
      this.getList();
      Message({
        message: "发布成功",
        type: "success",
      });
    },
    // async DelList() {
    //   const ids = [];
    //   this.selectData.forEach((item) => {
    //     ids.push(item.id);
    //   });
    //   const res = await DelRequierments(ids);
    //   await this.getViewData()
    //   this.getList();
    //   Message({
    //     type: "success",
    //     message: "删除成功",
    //   });
    //   this.selectData = [];
    //   console.log(res);
    // },
    async totalNum() {
      let totalCount = 0;
      const listNum = [];
      const cursorList = [];
      // 递归函数来获取所有数据
      const fetchAllData = async (currentCursor = null) => {
        try {
          const params = {
            page_size: this.pageSize, // 增大每页数量以减少请求次数
            // filter_status: 2,
            // filter_tags: '工业制造'
          };
          // 如果有游标，添加到参数中
          if (currentCursor) {
            params.cursor = currentCursor;
            console.log(currentCursor, "currentCursor");

            listNum.push(currentCursor);
          }

          const res = await GetRequierments(params);

          // 累加当前页的数据量
          if (res && res.requirements) {
            totalCount += res.requirements.length;
            this.cursorList.push(...res.requirements);
            console.log(this.cursorList, "cursorList");
          }

          // 检查是否还有下一页
          if (res && res.next_cursor && res.next_cursor !== "0") {
            // 递归调用获取下一页数据
            await fetchAllData(res.next_cursor);
          }
        } catch (error) {
          console.error("获取数据失败:", error);
          throw error;
        }
      };

      try {
        await fetchAllData();
        console.log("数据总量:", totalCount);
        this.totalnuber = totalCount;
        this.cursorList = listNum;
        console.log(this.cursorList, "cursorList");

        return totalCount;
      } catch (error) {
        console.error("计算总量失败:", error);
        return 0;
      }
    },
    async getList(val) {
      console.log(val);

      let obj = {
        page_size: this.pageSize,
      };

      if (val) {
        obj = {
          page_size: this.pageSize,
          cursor: this.cursorList[val - 2],
        };
      }
      
      if (this.title === "我发布的需求"||this.title==='我发布的数据需求') {
        console.log(this.cursorList, "this.cursorListaaa");
        if (this.cursorList && this.cursorList.length > 0) {
          const res= this.cursorList.filter((item) => {
           if(item.user_id===this.$store.state.userInfo.id){
            return item
           }
          });
          
          // 对过滤后的数据进行排序，待审核的排在前面
          const sortedData = res.sort((a, b) => {
            // 如果a是待审核状态(status === 2)，排在前面
            if (a.status === 2 && b.status !== 2) {
              return -1;
            }
            // 如果b是待审核状态，排在前面
            if (b.status === 2 && a.status !== 2) {
              return 1;
            }
            // 如果都是待审核或都不是待审核，保持原有顺序
            return 0;
          });
          
        this.ViewData=[...sortedData]
        console.log(this.ViewData,'this.ViewData');
        this.tableData1=this.ViewData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
        console.log(this.tableData1,'this.tableData1');
        this.totalnuberAll=sortedData.length
        } 
      } 
      else if(this.title==='原始需求列表') {
        console.log(this.cursorList,'this.cursorList原始');
        
        // 对原始需求列表也进行排序，待审核的排在前面
        const sortedCursorList = this.cursorList.sort((a, b) => {
          // 如果a是待审核状态(status === 2)，排在前面
          if (a.status === 2 && b.status !== 2) {
            return -1;
          }
          // 如果b是待审核状态，排在前面
          if (b.status === 2 && a.status !== 2) {
            return 1;
          }
          // 如果都是待审核或都不是待审核，保持原有顺序
          return 0;
        });
        
       this.tableData1=sortedCursorList.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
       this.ViewData=[...sortedCursorList]
       this.totalnuberAll=sortedCursorList.length
      }else if(this.title==='我收到的需求'){
        console.log(this.cursorList,'this.cursorList我收到的需求');
        if (this.cursorList && this.cursorList.length > 0) {
          const res= this.cursorList.filter((item) => {
           if(item.user_id!==this.$store.state.userInfo.id){
            return item
           }
          });
          
          // 对过滤后的数据进行排序，待审核的排在前面
          const sortedData = res.sort((a, b) => {
            // 如果a是待审核状态(status === 2)，排在前面
            if (a.status === 2 && b.status !== 2) {
              return -1;
            }
            // 如果b是待审核状态，排在前面
            if (b.status === 2 && a.status !== 2) {
              return 1;
            }
            // 如果都是待审核或都不是待审核，保持原有顺序
            return 0;
          });
          
        this.ViewData=[...sortedData]
        console.log(this.ViewData,'this.ViewData');
        this.tableData1=this.ViewData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
        console.log(this.tableData1,'this.tableData1');
        this.totalnuberAll=sortedData.length
        } 
        
      }
      
      if(
        this.tableData1.length===0
      ){
        if(this.currentPage>1){
          this.currentPage=this.currentPage-1
          this.getList()
        }
      }
      // const res = await GetRequierments(obj);
      // this.totalNum();
      // console.log(this.type,'this.type');

      // console.log('res.requirements',res.requirements);
      // this.tableData1 = res.requirements;
    },
    async handleShelves() {
      const ids = [];
      this.selectData.forEach((item) => {
        ids.push(item.id);
      });
      const res = await PatchRequierments({
        ids: ids,
        status: 6,
      });

      this.getList();
      Message({
        type: "success",
        message: "已下架",
      });
      this.selectData = [];
    },
    handleSelect(e) {
      console.log(e);
      this.selectData = e;
    },
    formatDate,
    hanlecheck() {
      if (this.checkAll) {
        this.itemList.forEach((item, index) => {
          this.itemList[index] = true;
        });
      } else {
        this.itemList.forEach((item, index) => {
          this.itemList[index] = false;
        });
      }
    },
    hanleDel() {
      this.isDel = true;
    },
    hanleOk() {
      this.isDel = false;
      this.isDel2=false
    },
    setData1(item){
      this.$router.push({
        path: "/formalRequirements",
        query: {
          ...item,
          roleType:this.type
        },
      });
    },
    setData(item) {
      this.$router.push({
        path: "/SetData",
        query: {
          ...item,
          roleType:this.type
        },
      });
    },
    UpData(item) {
      console.log(item);
      this.$router.push({
        path: "/DataDetail",
        query: {
          ...item,
          roleType:this.type
        },
      });
    },
    LookData(data) {
      console.log(data,'data');
      
      this.$router.push({
        path: "/DataDetail",
        query: {
          ...data,
        },
      });
    },
  },
};
</script>

<style scoped>
.disabled {
  cursor: not-allowed;
}
.industryList::-webkit-scrollbar {
  display: none;
}
.industryList {
  width: 100px;
  overflow-x: scroll;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;

  gap: 10px;
}
.pagination {
  display: flex;
  justify-content: end;
}
.delSpan {
  color: red !important;
}
.DataNumber-buttonList {
  display: flex;
  line-height: 30px;
}
.DataNumber-buttonList p {
  margin-right: 20px;
  font-family: Medium;
  font-size: 14px;
  color: #666;
}
.ButtonList {
  display: flex;
}
.takenOffTheShelves {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: Regular;
  color: #838690;
  margin-right: 20px;
}
.delete {
  width: 80px;
  height: 30px;
  background-color: red;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
  font-size: 14px;
  font-family: Regular;
  color: #fff;
}
.DataNumber {
  height: 36px;
  line-height: 36px;
  font-size: Medium;
  color: #666666;
}
::v-deep .el-table__body {
  /* -webkit-border-horizontal-spacing: 13px;   */
  -webkit-border-vertical-spacing: 13px;
}
.border1 {
  border: 1px solid #000;
  color: red;
}
.DataSpan {
  white-space: nowrap;
  overflow: hidden;
  /* width: 188px; */
  display: inline-block;
  width: 188px !important;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 47px;
}
::v-deep .number.active {
  background-color: #0d53ff;
  color: #fff;
  box-sizing: border-box;
}
::v-deep .el-pager .more::before {
  line-height: 18px;
}
::v-deep .el-pagination {
  font-size: 12px;
  padding-left: auto;
  font-family: Regular;
  box-sizing: border-box;
  /* width: 100%; */
  /* position: absolute;
  bottom: -30px;
  left: 120px; */
}
::v-deep .el-pager li.active + li {
  border-left: 1px solid #d9d9d9;
}
::v-deep .el-pager li {
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: auto;
  line-height: normal;
  height: auto;
  margin-right: 8px;
  color: #666666;
  box-sizing: border-box;
}
::v-deep .el-pager li:last-child {
  margin-right: 0;
}
.delbtn {
  background-color: #e92424;
  color: #fff;
}
.updatabtn {
  color: #838690;
  background-color: #fff;
}
.btn-list {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}
.btn-list button {
  font-size: 14px;
  width: 80px;
  height: 30px;
  font-family: Regular;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 15px;
}
.conten-box-p {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
}
.conten-box-title {
  margin-bottom: 4px;
  font-size: 16px;
  font-family: Medium;
}
.item-check {
  margin-left: 20px;
}
.img {
  width: 95px;
  height: 95px;
  border-radius: 6px;
  background-color: #d8d8d8;
  flex-shrink: 0;
  margin-left: 20px;
  margin-right: 12px;
}
.iconlist-item {
  display: flex;
  font-size: 12px;
  line-height: 13px;
  margin-right: 25px;
}
.iconlist-item img {
  width: 13px;
  height: 13px;
  object-fit: cover;
  margin-right: 3px;
}
.content-iconList {
  display: flex;
}
.item-content {
  width: 500px;
  display: flex;
}
.Datasets-item {
  width: 100%;
  height: 135px;
  border-radius: 4px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 8px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0d53ff;
}
.checkbox-All p {
  margin-left: 20px;
}
.checkbox-All {
  display: flex;
  flex-shrink: 0;

  align-items: center;
}
.checkbox-All {
  display: flex;
  /* color: #0D53FF; */
}
.Datasets-head {
  display: flex;
  justify-content: space-between;
  padding: 19px 20px;
  background-color: #f7f7f7;
  border-radius: 4px;
  margin-bottom: 12px;
}
.Datasets {
  margin-top: 33px;
}
.select-input {
  width: 164px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #cccccc;
  font-family: Regular;
}
.select-input input {
  width: 107px;
  height: 18px;
  margin-right: 17px;
  outline: none;
  border: none;
}
.select-input input::placeholder {
  font-family: Regular;
}
.active {
  color: #0d53ff;
}
.select-list p.active::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 2px;
  background-color: #0d53ff;
}
.select-list p {
  margin-right: 50px;
  position: relative;
  font-size: 14px;
}
.select-list {
  display: flex;
  flex-shrink: 0;
}
.select {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
}
.DataTable-container {
  height: 100%;
  box-sizing: border-box;
  padding: 24px;
  font-family: Regular;
  position: relative;
}
.head-title {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 24px;
}
</style>
<style>
.Datasets {
  border: none !important;
}

.Datasets .el-table {
  border: none !important;
}

.Datasets .el-table::before {
  display: none !important;
}

.Datasets .el-table__header-wrapper {
  border: none !important;
}

.Datasets .el-table__header th {
  border: none !important;
  background-color: transparent !important;
}

.Datasets .el-table__header .cell {
  border: none !important;
  font-family: Medium;
  font-size: 12px;
  color: #000;
}
.Datasets .el-table__header .cell .el-dropdown {
  font-family: Medium;
  font-size: 12px;
  color: #000;
}
.Datasets .el-table__body .cell {
  border: none !important;
  font-family: Regular;
  font-size: 12px;
  color: #666666;
}
.Datasets .el-table__header .has-gutter tr {
  background-color: #f8f8f8;
}

.Datasets .el-table__header .el-checkbox__inner {
  display: none;
}

.Datasets .el-table__header tr {
  border: none !important;
}

.Datasets .el-table__body td {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 !important;
  border: 1px solid #eee !important;
}

/* 第一列只移除右边框，添加左边圆角 */
.Datasets .el-table__body td:first-child {
  border-right: none !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

/* 中间列只添加上下边框 */
.Datasets .el-table__body td:not(:first-child):not(:last-child) {
  border-top: 1px solid #eee !important;
  border-bottom: 1px solid #eee !important;
  border-left: none !important;
  border-right: none !important;
}

/* 最后一列不添加左边框，添加右边圆角 */
.Datasets .el-table__body td:last-child {
  border-top: 1px solid #eee !important;
  border-bottom: 1px solid #eee !important;
  border-right: 1px solid #eee !important;
  border-left: none !important;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

/* 移除表格默认边框 */
.Datasets .el-table__body-wrapper {
  border: none !important;
}

.Datasets .el-table__inner-wrapper {
  border: none !important;
}

.pagination .el-pagination {
  font-family: Regular;
  font-size: 12px;
  color: #666666;
}
.pagination .el-pagination .el-pager .number {
  font-family: Regular;
  font-size: 12px;
  color: #666666;

  /* height: 28px; */
}
.pagination .el-pagination .el-pager .active {
  font-family: Regular;
  font-size: 12px;
  color: #fff;
  /* width: 28px; */
  /* height: 28px; */
}
.pagination .el-pagination .el-pagination__total {
  margin-top: 3px;
}
.pagination .el-pagination .el-icon.el-icon-arrow-left {
  margin-top: 1px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 9.5px 9.5px;
}
.pagination .el-pagination .el-icon.el-icon-arrow-right {
  margin-top: 1px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 9.5px 9.5px;
}
.pagination .el-pagination .el-input.el-input--mini.el-input--suffix {
  margin-top: 3px;
}
.pagination .el-pagination .el-pagination__jump {
  margin-top: 3px;
}
</style>
